import axiosInstance from '../../../../config/axiosInstance';
import { CurrencyValidation } from "../../views/Currency/Validation/CurrencyValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors,redirectCallback,redirectRoleList) => {
  
  event.preventDefault();
  const formErrors = CurrencyValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      
      const CompanyID=localStorage.getItem("CompanyID");
      formData.ClientID=CompanyID;
      const response = await axiosInstance.post(`/Setup/CreateCurrency`, formData);
      setFormData({
        vc_CurrencyName: '',vc_CurrencyCode:'',vc_CurrencySymbol:'',dec_CurrencyToBaseRate:'',
        dec_BaseToCurrencyRate:'',vc_MajorCurrency:'',vc_MinorCurrency:''        
        // Reset other fields as needed
      });
      redirectRoleList();
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };